import { Center } from "@/components/ui/center";
import { HStack } from "@/components/ui/hstack";
import { Pressable } from "@/components/ui/pressable";
import { Text } from "@/components/ui/text";
import { T } from "@transifex/react";
import { router } from "expo-router";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Center className="bg-primary-100 border-t border-outline-300 gap-[15px] mt-auto px-[74px] py-[32px]">
      <HStack className="flex-row gap-[16px] justify-center">
        <Pressable className="active:opacity-70" onPress={() => router.push("/privacy-policy")}>
          <Text className="font-[400] leading-[14.52px] text-[12px] text-typography-900 underline">
            <T _str="Privacy Policy" />
          </Text>
        </Pressable>
        <Text className="font-[500] leading-[14.09px] text-[12px] text-typography-900 underline">|</Text>
        <Pressable className="active:opacity-70" onPress={() => router.push("/terms-of-use")}>
          <Text className="font-[400] leading-[14.52px] text-[12px] text-typography-900 underline">
            <T _str="Terms of Use" />
          </Text>
        </Pressable>
      </HStack>
      <Text className="font-[400] leading-[14.52px] text-[12px] text-center text-typography-900">
        <T
          _str={`© {year} IPC Technology Group, LLC.
All rights reserved.`}
          year={currentYear}
        />
      </Text>
    </Center>
  );
};

export default Footer;
